import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-media-management',
  templateUrl: './social-media-management.component.html',
  styleUrls: ['./social-media-management.component.css']
})
export class SocialMediaManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
